package com.vamvisions.main.i18n

import androidx.compose.runtime.staticCompositionLocalOf
import com.vamvisions.main.core.presentation.i18n.EnStrings
import com.vamvisions.main.core.presentation.i18n.Strings

/** The interface strings of the active language. The app root provides them from `AppShellState`. */
val LocalStrings = staticCompositionLocalOf<Strings> { EnStrings }
